import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessAddFairProduct} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessAddFairProductPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.MyBusinessAddFairProductPage;
  }

  render() {
    return (
      <MasterLayout isActive='my-business-post-product'>
        <MyBusinessAddFairProduct params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessAddFairProductPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessAddFairProductPage.jsx